import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ManageFolders from "./routes/ManageFolders";
import PostDetailRoute from "./routes/PostDetailRoute";
export default store => ({
  path: "journal",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-journal" */ "./components"),
        import(
          /* webpackChunkName: "course-journal" */ "./modules/JournalModule"
        ),
        import(
          /* webpackChunkName: "course-journal" */ "Post/modules/PostModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const post = importedModule2.default;
        injectReducer(store, {
          key: "post",
          reducer: post,
        });
        injectReducer(store, {
          key: "journal",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ManageFolders(store), PostDetailRoute(store)],
});
